// extracted by mini-css-extract-plugin
export default {"wrapper":"Detail_wrapper__4k1ag","col":"Detail_col__tCu7W"};